'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: '請選擇時間'
};

exports['default'] = locale;